<template>
    <div class="Header">
        <!-- <Navigation v-if="$root.isPhone && is_open && !open_training"/> -->
        <div class="Header__container" :class="[{ 'is-demo': use_demo }, { 'is-desktop': use_demo && !$root.is_phone }]"> 
            
            <div class="Header__icon" 
                :class="{ locked: locked && $route.meta.name == 'welcome' }" 
                @click="onClick('welcome')">
                <Crest/>
            </div>

            <!-- <template v-if="!$root.isPhone"> -->
                <div class="Header__block row">  
                    <div class="Header__btn" v-for="(btn, index) in arr" :key="index" @click="onClick(btn)" :class="{ added: $route.meta.name == btn }">
                        {{ trans('Navigation.'+ btn) }}
                        <div class="Header__btn-line" :class="{ added: $route.meta.name == btn }" />
                    </div>
                    <div ref="motion" @click="$root.langSwitch()" class="App-lang" :class="getTint()" v-html="lang == 'fr' ? 'EN' : 'FR'" />
                </div>
            <!-- </template> -->
           <!--  <template v-if="$root.isPhone">
                <div ref="motion" class="Header__burger" @click="burgerClick()">
                    <Hamburger ref="burger"/>
                </div>
            </template> -->
        </div>
    </div>
</template>

<script>

import gsap from "gsap"
import Colors from '@/config/Colors'
import Crest from '@/components/assets/svg/Crest'
import Navigation from '@/components/assets/Navigation'
import Hamburger from '@/components/assets/Hamburger'
import ScrollToPlugin from "gsap/ScrollToPlugin"

gsap.registerPlugin(ScrollToPlugin)

export default {

    name: 'Header',
    components: { Crest, Hamburger, Navigation },
    data: ()=>({
        arr: [],
        arr_phone: [],
        is_open: false,
        use_demo: false
    }),
    computed:{
        open_training() { return this.$store.getters['commons/open_training'] },
        locked() { return this.$store.getters['commons/header_locked'] },
        is_demo() { return this.$store.getters['commons/is_demo'] },
        tint() { return this.$store.getters['commons/tint'] }
    },

    watch: {

        open_training(nw) {

            if(nw == 'close') {
                this.is_open = false
                this.use_demo = false
            }

            else 
                if(nw)
                    gsap.delayedCall(.25, ()=> this.is_open = true)
        },

        is_demo(nw) {

            

            if(nw){
                this.use_demo = true
                // gsap.delayedCall(.25, ()=> this.use_demo = true)
            }
        },

    },

    mounted() { 
        this.$nextTick(()=>{
            const delay = this.$route.meta.name == 'welcome' ? 3.8 : 1.5
            gsap.from(['.Header', this.$refs.motion], { 
                stagger: .2,
                duration: .35, 
                opacity: 0, 
                y: -100, 
                delay: delay, 
                ease: 'back.out' 
            })
        })
    },
    methods: {
        onClick(link) {

            // if(this.open_training){
            //     this.$store.commit('commons/OPEN_TRAINING', 'close')
            //     return
            // }

            if(link == 'welcome')
                this.is_open = false


            if(link == 'welcome' && this.$route.meta.name == 'welcome') {
                if(!this.$root.isPhone)
                    gsap.to(".App-container", { 
                        scrollTo: { y: 0, autoKill: true },
                        duration: .75, 
                        ease: 'cubic.out'
                    }) 
            }
            else 
                if(link != this.$route.meta.name) 
                    gsap.to(".App-page", {  
                        opacity: 0, 
                        duration: .25, 
                        ease: 'none', 
                        onComplete: ()=>{ this.updateRoute(link) }
                    })
                else 
                    this.updateRoute(link)
     
        },
        updateRoute(link) {
            // this.burgerClick()
            this.$router.push({ name: link +'.' + this.lang }).catch(() => {})
        },
        getTint() {
            return this.tint
        },
        burgerClick() {

            if(this.open_training){
                this.$store.commit('commons/OPEN_TRAINING', 'close')
                this.$store.commit('commons/IS_DEMO', false)
            }
            else
                this.is_open = !this.is_open
        },
    }
}
</script>

<style lang='stylus'>

@import '~@/commons/stylus/Media-queries'
@import '~@/config/Settings'

.Header
    width 100%
    position fixed
    top 0
    left 50%
    transform translateX(-50%)
    width 100%
    max-width 880px 
    font-family factoria
    display flex
    justify-content center
    align-items center
    z-index 1000
    overflowY hidden

    &__container
        width 100%
        height var(--hd)
        display flex
        justify-content space-between
        align-items center
        padding 0 calc(var(--mw)/2) 
        background-color rgba(white, 1)
        box-shadow 0px 4px 4px -2px rgba(0,0,0,0.25)
        transition opacity .25s, transform .5s

        z-index 200  

        &.is-demo 
            background-color rgba(white, 0)  

            & .Header__icon
                transform translateY(-120px)
                transition-delay .25s
                transform .5s

        &.is-desktop
            transform translateY(-80px)
            transition-delay 0s

    &__icon
        width 68px
        padding-top 48px
        cursor pointer
        transition opacity .25s, transform .5s
        opacity 1

        &.locked
            transform translateY(-20px)
            opacity 0

    &__btn
        display flex
        align-items center
        padding 0 calc(var(--mw)/2) 
        cursor pointer
        position relative

        &.added
            font-weight 500

        +below(portrait)
            font-size .88em

        +below(phone)
            font-size .81em

        &-line 
            position absolute
            height 1px
            background-color rgba(dark, 1)
            bottom 4px
            transition width .2s
            transition-timing-function ease-out 
            width 0

            &.added
                width calc(100% - var(--mw))

    &__burger
        position fixed
        top calc((var(--hd)/2) - 8px)
        left calc(100% - (var(--mw) + 16px))
        width 25px
        height 25px

</style>


